import { inject, Injectable } from '@angular/core';
import type { Permissions } from '@dev-fast/types';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';

import { UserState } from '@app/core/state/user-store';
import type { HasPermissionEngine } from '@app/shared/directives/has-permission/symbols';

@Injectable()
export class HasPermissionService implements HasPermissionEngine {
  readonly #store = inject(Store);

  readonly permissions$: Observable<Permissions[]> = this.#store.select(UserState.permissions);
}
